import { createRouter, createWebHistory } from 'vue-router'
import { hasRoutePermission } from '../utils/permission'

const routes = [
  {
    path: '/',
    redirect: (to) => {
      // 检查是否有token
      console.log(to);
      const token = localStorage.getItem('token')
      return token ? '/home' : '/login'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '用户登录',
      requiresAuth: false,
      hideLayout: true
    }
  },
  {
    path: '/profile',
    name: 'ProfilePage',
    component: () => import('../views/Profile.vue'),
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/robots',
    name: 'Robots',
    component: () => import('../views/Robots.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/wechat-groups',
    name: 'WechatGroups',
    component: () => import('../views/WechatGroups.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/wechat-contacts',
    name: 'WechatContacts',
    component: () => import('../views/WechatContacts.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import('../views/Messages.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/send-messages',
    name: 'SendMessages',
    component: () => import('../views/SendMessages.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/ai-auto',
    name: 'AiAuto',
    component: () => import('../views/AiAuto.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/task',
    name: 'Task',
    component: () => import('../views/Task.vue'),
    meta: {
      title: '任务管理',
      requiresAuth: true
    }
  },
  {
    path: '/video-tutorials',
    name: 'VideoTutorials',
    component: () => import('../views/VideoTutorials.vue'),
    meta: {
      title: '视频教程',
      requiresAuth: true
    }
  },
  {
    path: '/api-doc',
    name: 'ApiDoc',
    component: () => import('../views/ApiDoc.vue'),
    meta: {
      title: '接口文档',
      requiresAuth: true
    }
  },
  {
    path: '/api-debug',
    name: 'ApiDebug',
    component: () => import('../views/ApiDebug.vue'),
    meta: {
      title: 'API调试',
      requiresAuth: true
    }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: () => import('../views/UserManagement.vue'),
    meta: {
      title: '用户管理',
      requiresAuth: true
    }
  },
  {
    path: '/role-management',
    name: 'RoleManagement',
    component: () => import('../views/RoleManagement.vue'),
    meta: {
      title: '角色管理',
      requiresAuth: true
    }
  },
  {
    path: '/permission-management',
    name: 'PermissionManagement',
    component: () => import('../views/PermissionManagement.vue'),
    meta: {
      title: '权限管理',
      requiresAuth: true
    }
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: () => import('../views/NoPermission.vue'),
    meta: {
      title: '访问受限',
      requiresAuth: false,
      hideLayout: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加路由错误处理
router.onError((error) => {
  // 忽略路由重定向错误
  if (error.message && error.message.includes('Redirected from') && error.message.includes('via a navigation guard')) {
    return
  }
  
  // 处理导航失败错误
  if (error.type === 2) {
    setTimeout(() => {
      router.push('/no-permission')
    }, 100)
    return
  }
  
  console.error('路由错误:', error)
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.meta.requiresAuth !== false // 默认需要认证，只有明确设置为false的路由才不需要认证
  
  // 如果访问登录页面
  if (to.path === '/login') {
    // 如果已经登录，跳转到首页
    if (token) {
      next('/home')
      return
    }
    // 未登录可以访问登录页面
    next()
    return
  }
  
  // 对于其他页面，检查是否需要认证
  if (requiresAuth && !token) {
    // 需要认证但没有token，跳转到登录页面
    next('/login')
    return
  }
  
  // 检查权限（排除登录页面和无权限页面）
  if (requiresAuth && token && to.path !== '/no-permission') {
    // 检查用户是否有访问该路由的权限
    const hasPermission = hasRoutePermission(to.path)
    
    if (!hasPermission) {
      // 静默重定向到无权限页面
      next('/no-permission')
      return
    }
  }
  
  // 继续导航
  next()
})

export default router 